export const setPriValue = (pri: any) => {
  const priItem = pri.map(
    (item: any) =>
      `Telefon Numarasi: ${item.phone} - Blok:${item.block} - Did Sayısı:${item.didcount}<br/>`
  );
  return priItem;
};
